import React from "react";
import VideoBlogIndex from "../../../components/video-blog-index";
import db from "../../../utils/blogs-front/english/blog-english.json";
import { videoBlogIndexStaticProps } from "../../../utils/video-blog-index-props";

export async function getStaticProps() {
	return videoBlogIndexStaticProps(db);
}

export default function VideoBlogsIndexPage({ db, lcpThumbPreload }) {
	return <VideoBlogIndex locale="en" db={db} lcpThumbPreload={lcpThumbPreload} />;
}
